module.exports = __webpack_public_path__ + "static/media/thank-you.280de490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thank-you.jpg
// module id = 370
// module chunks = 33